/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Capitalise the first letter in a supplied string
 */
export const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

/**
 * Attempt to parse a supplied value as a URL, optionally using a supplied base domain
 * @returns A `URL` object, if the value was successfully parsed; else, `undefined`
 */
export const parseUrl = (url?: string | URL | null, base?: string) => {
  // If a relative URL path string was supplied without a base, attempt to populate a base domain
  if (typeof url === 'string' && url.startsWith('/') && !base) {
    base =
      typeof window !== 'undefined'
        ? window.location.origin
        : process.env.NEXT_PUBLIC_WEBSITE_URL;
  }
  return !!url &&
    (stringHasValue(url) || typeof url === 'object') &&
    URL.canParse(url, base)
    ? new URL(url, base)
    : undefined;
};

/**
 * Determine whether a given value is a string with a valid, non-whitespace value
 */
export const stringHasValue = (string: any) =>
  typeof string === 'string' && string.trim() !== '';

/**
 * @returns The trimmed contents of a string, if it has a valid, non-whitespace value; else, `undefined`
 */
export const stringValue = (string: any) =>
  stringHasValue(string) ? (string as string).trim() : undefined;
